import { Box, Flex, Text } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  name: string;
  description: string;
  onClick?: () => void;
};

export function SuggestedActionCard({ name, description, onClick }: Props) {
  return (
    <Box
      bg="gray.1"
      p="sm"
      style={{ width: 'fit-content', borderRadius: 12, cursor: onClick ? 'pointer' : undefined }}
      onClick={onClick}
    >
      <Flex justify="space-between" align="center" gap="sm">
        <Text size="textSm" fw={FONT_WEIGHTS.semibold} c="gray.10">
          {name}
        </Text>
        <IconChevronRight
          size={16}
          color="var(--mantine-color-gray-10)"
          style={{ flexShrink: 0 }}
        />
      </Flex>
      <Text size="textXs" fw={FONT_WEIGHTS.medium} c="gray.7">
        {description}
      </Text>
    </Box>
  );
}
